// import React, { useEffect, useState } from "react";
// import logo from "../assets/images/gameofyy.png";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";

// const Login = () => {
//   const location = useLocation();
//   const [loading, setLoading] = useState(false);
//   const [errorModalOpen, setErrorModalOpen] = useState(false); // State to control modal visibility
//   const [errorMessage, setErrorMessage] = useState(""); // State to store error message
//   const searchParams = new URLSearchParams(location.search);
//   const initialMsisdn = searchParams.get("msisdn");
//   const [msisdn, setMsisdn] = useState(initialMsisdn || "");
//   const navigate = useNavigate();

//   // Function to check if the "gameoffy" cookie exists and navigate if it does
//   const checkCookieAndNavigate = () => {
//     const cookies = document.cookie.split("; ");
//     console.log("All cookies:", cookies);

//     const gameofyyCookie = cookies.find((cookie) => cookie === "gameofyy=1");

//     if (gameofyyCookie) {
//       console.log("Cookie 'gameofyy=1' found!");
//       // Navigate to the desired URL
//       //
//       window.location.href = "/home";
//     } else {
//       console.log("Cookie 'gameofyy=1' not found.");
//     }
//   };
//   const checkAllCookies = () => {
//     const cookies = document.cookie.split("; ");
//     console.log("All cookies:", cookies);
//   };

//   useEffect(() => {
//     checkCookieAndNavigate();
//     checkAllCookies();
//   }, []); // Run only once when the component mounts

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true); // Set loading state to true when submitting

//     console.log(msisdn);
//     // Call your API endpoint here using Axios or any other method
//     // Example:
//     axios
//       // .post(`http://localhost:5086/subscribe/user`, {
//       .post(`/subscribe/user`, {
//         msisdn,
//         mact: "web",
//         service_name: "gameofyy",
//       })
//       .then((response) => {
//         console.log("Response data:", response.data);
//         if (response.data === "Success") {
//           // Set cookie if response is success
//           document.cookie = "gameofyy=1; path=/"; // Set cookie named "gameofyy" with value "1" and path "/"
//           navigate(`/home`);
//         } else {
//           // Show error modal if response is not success
//           setErrorModalOpen(true);
//           setErrorMessage(response.data); // Set error message in state
//         }
//       })
//       .catch((error) => {
//         console.error("Error checking user:", error.response.data);
//         if (error.response.data === "User Already Exist") {
//           console.log("here user==>>>");
//           document.cookie = "gameofyy=1; path=/"; // Set cookie named "gameofyy" with value "1" and path "/"
//           navigate(`/home`);
//         } else {
//           setErrorModalOpen(true);
//           setErrorMessage(error.response.data); // Set error message in state
//           navigate("/home/login");
//         }
//         // Show error modal
//       })
//       .finally(() => {
//         setLoading(false); // Set loading state to false after receiving response
//       });
//   };

//   return (
//     <div className="bg-[#623193] h-screen">
//       {/* Loader */}
//       {loading && (
//         <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
//           <div className="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-gray-300"></div>
//         </div>
//       )}

//       {/* Error modal */}
//       {errorModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
//           <div className="relative w-auto max-w-3xl mx-auto my-6">
//             {/*content*/}
//             <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
//               {/*header*/}
//               <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
//                 <h3 className="text-3xl font-semibold">Error</h3>
//                 <button
//                   className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
//                   onClick={() => setErrorModalOpen(false)}
//                 >
//                   <span className="text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
//                     ×
//                   </span>
//                 </button>
//               </div>
//               {/*body*/}
//               <div className="relative p-6 flex-auto">
//                 <p className="my-4 text-gray-600 text-lg leading-relaxed">
//                   {errorMessage}
//                 </p>
//               </div>
//               {/*footer*/}
//               <div className="flex items-center justify-end p-6 border-t border-solid border-gray-300 rounded-b">
//                 <button
//                   className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
//                   type="button"
//                   onClick={() => setErrorModalOpen(false)}
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Rest of the JSX */}
//       <div className="container mx-auto flex flex-col justify-center py-[90px]">
//         <div className=" mx-auto">
//           <img className="rounded-t-lg h-20 w-20" src={logo} alt="" />
//         </div>
//         <div className="flex justify-center py-3">
//           <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
//             <div className="p-5 shadow-xl shadow-purple-600 ">
//               <div className="w-full max-w-sm p-2  bg-white border border-gray-200 rounded-lg shadow sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700">
//                 <form className="space-y-4" action="#" onSubmit={handleSubmit}>
//                   <h5 className="text-2xl  text-[#6B57EF] font-bold text-center capitalize dark:text-white">
//                     {/* SIGN UP TO ENJOY ! */}
//                     Souscrivez et Profitez!
//                   </h5>
//                   {initialMsisdn ? (
//                     <div>
//                       <label
//                         htmlFor="number"
//                         className="block mb-2 text-sm font-medium text-gray-700 dark:text-grey-700"
//                       >
//                         MSISDN
//                       </label>
//                       <input
//                         type="text"
//                         name="number"
//                         id="number"
//                         value={msisdn}
//                         readOnly
//                         className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
//                         placeholder="*********"
//                         required
//                       />
//                     </div>
//                   ) : (
//                     <div>
//                       <label
//                         htmlFor="number"
//                         className="block mb-2 text-sm font-medium text-gray-700 dark:text-grey-700"
//                       >
//                         {/* Enter MSISDN */}
//                         Veuillez entrer votre numéro
//                       </label>
//                       <input
//                         type="number"
//                         name="number"
//                         id="number"
//                         value={msisdn}
//                         onChange={(e) => setMsisdn(e.target.value)}
//                         className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
//                         placeholder="*********"
//                         required
//                       />
//                     </div>
//                   )}

//                   <button
//                     type="submit"
//                     className="w-full text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
//                   >
//                     {/* Subscribe Now */}
//                     Souscrivez maintenant
//                   </button>
//                 </form>
//                 {!initialMsisdn && (
//                   <p className="text-sm text-gray-700 dark:text-grey-700 text-center mt-2">
//                     {/* Please use Mobile Data for better enjoyment */}
//                     Veuillez svp utiliser votre connexion mobile pour une
//                     meilleure expérience
//                   </p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// ================live ===================

// import React, { useEffect, useState } from "react";
// import logo from "../assets/images/gameofyy.png";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";

// const Login = () => {
//   const location = useLocation();
//   const [loading, setLoading] = useState(false);
//   const [errorModalOpen, setErrorModalOpen] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const searchParams = new URLSearchParams(location.search);
//   const initialMsisdn = searchParams.get("msisdn");
//   const [msisdn, setMsisdn] = useState(initialMsisdn || "");
//   const [subscriptionType, setSubscriptionType] = useState("Daily");
//   const navigate = useNavigate();

//   const checkCookieAndNavigate = () => {
//     const cookies = document.cookie.split("; ");
//     const gameofyyCookie = cookies.find((cookie) => cookie === "gameofyy=1");

//     if (gameofyyCookie) {
//       window.location.href = "/home";
//     }
//   };

//   useEffect(() => {
//     checkCookieAndNavigate();
//   }, []);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     axios
//       .post(`/subscribe/user`, {
//         msisdn,
//         mact: "web",
//         service_name: "gameofyy",
//         subscription_type: subscriptionType,
//       })
//       .then((response) => {
//         if (response.data == "Success") {
//           document.cookie = "gameofyy=1; path=/";
//           navigate(`/home?msisdn=${msisdn}`);
//         } else {
//           setErrorModalOpen(true);
//           setErrorMessage(response.data);
//         }
//       })
//       .catch((error) => {
//         if (error.response.data === "User Already Exist") {
//           document.cookie = "gameofyy=1; path=/";
//           navigate(`/home`);
//         } else {
//           setErrorModalOpen(true);
//           setErrorMessage(error.response.data);
//         }
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   return (
//     <div className="bg-[#623193] h-screen flex items-center justify-center">
//       {loading && (
//         <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
//           <div className="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-gray-300"></div>
//         </div>
//       )}

//       {errorModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
//           <div className="relative w-auto max-w-3xl mx-auto my-6">
//             <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
//               <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
//                 <h3 className="text-3xl font-semibold">Error</h3>
//                 <button
//                   className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
//                   onClick={() => setErrorModalOpen(false)}
//                 >
//                   <span className="text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
//                     ×
//                   </span>
//                 </button>
//               </div>
//               <div className="relative p-6 flex-auto">
//                 <p className="my-4 text-gray-600 text-lg leading-relaxed">
//                   {errorMessage}
//                 </p>
//               </div>
//               <div className="flex items-center justify-end p-6 border-t border-solid border-gray-300 rounded-b">
//                 <button
//                   className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
//                   type="button"
//                   onClick={() => setErrorModalOpen(false)}
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="flex flex-col justify-center">
//         <div className="flex justify-center">
//           <img className="h-20 w-20 mb-4" src={logo} alt="" />
//         </div>
//         <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 w-full max-w-sm">
//           <div className="flex flex-col items-center">
//             <h5 className="text-2xl text-[#6B57EF] font-bold text-center mb-6">
//               Souscrivez et Profitez!
//             </h5>
//           </div>
//           <form className="space-y-4" action="#" onSubmit={handleSubmit}>
//             <div>
//               <label
//                 htmlFor="number"
//                 className="block mb-2 text-sm font-medium text-gray-700"
//               >
//                 Veuillez entrer votre numéro
//               </label>
//               <input
//                 type="number"
//                 name="number"
//                 id="number"
//                 value={msisdn}
//                 onChange={(e) => setMsisdn(e.target.value)}
//                 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
//                 placeholder="*********"
//                 required
//               />
//             </div>

//             {/* Subscription Type Dropdown */}
//             <div>
//               <label
//                 htmlFor="subscriptionType"
//                 className="block mb-2 text-sm font-medium text-gray-700"
//               >
//                 Type d'abonnement
//               </label>
//               <select
//                 name="subscriptionType"
//                 id="subscriptionType"
//                 value={subscriptionType}
//                 onChange={(e) => setSubscriptionType(e.target.value)}
//                 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
//                 required
//               >
//                 <option value="Daily">Jour : Souscrivez à partir de 50F</option>
//                 <option value="3Day">3 jours : Souscrivez à 100F</option>
//                 <option value="Weekly">Hebdo : Souscrivez à partir de 150F</option>
//               </select>
//             </div>

//             <button
//               type="submit"
//               className="w-full text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center shadow-lg shadow-purple-500/50"
//             >
//               Souscrivez maintenant
//             </button>
//           </form>
//           {!initialMsisdn && (
//             <p className="text-sm text-gray-700 text-center mt-4">
//               Veuillez svp utiliser votre connexion mobile pour une meilleure
//               expérience
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;



import React, { useEffect, useState } from "react";
import logo from "../assets/images/gameofyy.png";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const searchParams = new URLSearchParams(location.search);
  const initialMsisdn = searchParams.get("msisdn");
const extRef =
  location.search.match(/[&$]ext_ref=([^&$]*)/)?.[1] || ""; 
  
  const [msisdn, setMsisdn] = useState(initialMsisdn || "");
  const [subscriptionType, setSubscriptionType] = useState("Daily");
  const navigate = useNavigate();

  // ---- GA helper (inline to keep this file self-contained) ----
  const gtagSafe = (name, params = {}) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  };
  // sanitize error reasons to a small whitelist (avoid leaking server details)
  const mapErrorReason = (raw) => {
    if (!raw) return "unknown";
    const s = String(raw).toLowerCase();
    if (s.includes("non-compliant")) return "non_compliant";
    if (s.includes("timeout")) return "timeout";
    if (s.includes("exist")) return "user_exists";
    if (s.includes("invalid")) return "invalid_input";
    if (s.includes("network")) return "network_error";
    return "other";
  };

  const checkCookieAndNavigate = () => {
    const cookies = document.cookie.split("; ");
    const gameofyyCookie = cookies.find((cookie) => cookie === "gameofyy=1");

    if (gameofyyCookie) {
      // track cookie-based redirect
      gtagSafe("cookie_redirect", {
        page: "Login",
        destination: "/home",
      });
      window.location.href = "/home";
    }
  };

  useEffect(() => {
    checkCookieAndNavigate();

    // Count arrivals on this page
    gtagSafe("screen_view", {
      firebase_screen: "Login",
      screen_name: "Login",
      page_path: window.location.pathname + window.location.search,
      hostname: window.location.hostname,
    });

    // Custom page marker for simpler reporting
    gtagSafe("login_page_view", {
      has_prefilled_msisdn: Boolean(initialMsisdn),
      source: initialMsisdn ? "query_param" : "manual",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Track form submit intent (no PII)
    gtagSafe("subscription_attempt", {
      plan: subscriptionType.toLowerCase(), // 'daily' | '3day' | 'weekly'
      currency: "XOF",
      source: initialMsisdn ? "prefilled" : "manual",
    });

    axios
      .post(`/subscribe/user`, {
        msisdn,                   // sent to your backend; NOT to GA
        mact: "web",
        service_name: "gameofyy",
        subscription_type: subscriptionType,
         ext_ref: extRef,
      })
      .then((response) => {
        if (response.data == "Success") {
          // Track success
          gtagSafe("subscription_success", {
            plan: subscriptionType.toLowerCase(),
            currency: "XOF",
          });

          document.cookie = "gameofyy=1; path=/";
          navigate(`/home?msisdn=${encodeURIComponent(msisdn)}`);
        } else {
          // Track failure with sanitized reason
          gtagSafe("subscription_failed", {
            reason: mapErrorReason(response.data),
          });

          setErrorModalOpen(true);
          setErrorMessage(response.data);
        }
      })
      .catch((error) => {
        const serverMsg = error?.response?.data;

        if (serverMsg === "User Already Exist") {
          // Track as success path (user already active)
          gtagSafe("subscription_success", {
            plan: subscriptionType.toLowerCase(),
            currency: "XOF",
            note: "user_already_exists",
          });

          document.cookie = "gameofyy=1; path=/";
            navigate(`/home?msisdn=${encodeURIComponent(msisdn)}`);
          // navigate(`/home`);
        } else {
          // Track failure
          gtagSafe("subscription_failed", {
            reason: mapErrorReason(serverMsg),
          });

          setErrorModalOpen(true);
          setErrorMessage(serverMsg || "Unknown error");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="bg-[#623193] h-screen flex items-center justify-center">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
          <div className="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-gray-300"></div>
        </div>
      )}

      {errorModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
          <div className="relative w-auto max-w-3xl mx-auto my-6">
            <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
              <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
                <h3 className="text-3xl font-semibold">Error</h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => setErrorModalOpen(false)}
                >
                  <span className="text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <p className="my-4 text-gray-600 text-lg leading-relaxed">
                  {errorMessage}
                </p>
              </div>
              <div className="flex items-center justify-end p-6 border-t border-solid border-gray-300 rounded-b">
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                  type="button"
                  onClick={() => setErrorModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col justify-center">
        <div className="flex justify-center">
          <img className="h-20 w-20 mb-4" src={logo} alt="Game Logo" />
        </div>
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 w-full max-w-sm">
          <div className="flex flex-col items-center">
            <h5 className="text-2xl text-[#6B57EF] font-bold text-center mb-6">
              Souscrivez et Profitez!
            </h5>
          </div>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="number"
                className="block mb-2 text-sm font-medium text-gray-700"
              >
                Veuillez entrer votre numéro
              </label>
              <input
                type="number"
                name="number"
                id="number"
                value={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder="*********"
                required
              />
            </div>

            <div>
              <label
                htmlFor="subscriptionType"
                className="block mb-2 text-sm font-medium text-gray-700"
              >
                Type d'abonnement
              </label>
              <select
                name="subscriptionType"
                id="subscriptionType"
                value={subscriptionType}
                onChange={(e) => setSubscriptionType(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                required
              >
                <option value="Daily">Jour : Souscrivez à partir de 50F</option>
                <option value="3Day">3 jours : Souscrivez à 100F</option>
                <option value="Weekly">Hebdo : Souscrivez à partir de 150F</option>
              </select>
            </div>

            <button
              type="submit"
              className="w-full text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center shadow-lg shadow-purple-500/50"
            >
              Souscrivez maintenant
            </button>
          </form>
          {!initialMsisdn && (
            <p className="text-sm text-gray-700 text-center mt-4">
              Veuillez svp utiliser votre connexion mobile pour une meilleure
              expérience
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;


